Ext.define('PanelCtxFirmaChooser', {
    extend: 'Ext.form.Panel',
    xtype: 'panelctxfirmachooser',
    cls: 'ctx-firma-chooser',
    scrollable: false,
    config: {
        dataFS: null,
        currentObject: null
    },
    initComponent: function() {
        this.items = [{
            id: this.id + "ffilter",
            xtype: 'textfieldexd',
            allowBlank: true,
            maxLength: 200,
            emptyText: Lang.szukaj,
            listeners: {
                scope: this,
                change: function (textfield, newValue, oldValue) {
                    this.filterRadioItems(newValue);
                }
            }
        }, {
            xtype: 'container',
            scrollable: 'vertical',
            maxHeight: 130,
            minHeight: 130,
            items: [{
                xtype: 'radiogroupexd',
                columns: 1,
                vertical: true,
                items: this.buildRadioItems(this.dataFS)
            }]
        }];
        this.buttons = [{
                id: this.cid + 'cancel',
                text: Lang.anuluj,
                ui: 'btn-secondary-s',
                cls: 'ctx-firma-chooser-btn',
                scope: this,
                handler: this.closeOp
            }, {
                id: this.cid + 'save',
                text: Lang.zapisz,
                ui: 'btn-primary-s',
                cls: 'ctx-firma-chooser-btn',
                scope: this,
                handler: this.saveOp
            }, {
            xtype: 'tbfill',
            height: 40
        },
        ];
        this.callParent();
    },

    buildRadioItems: function(dataFS) {
        var items = [{
            boxLabel: Lang.wszystkie,
            name: 'ctxfirma',
            inputValue: 0,
            checked: (this.currentObject === 0 || this.currentObject === null)
        }];
        if (dataFS) {
            dataFS.forEach(function(item) {
                items.push({
                    boxLabel: item.nazwa,
                    name: 'ctxfirma',
                    inputValue: item.id,
                    checked: this.currentObject === item.id
                });
            }, this);
        }
        return items;
    },
    filterRadioItems: function(filterText) {
        var filteredItems = this.dataFS.filter(function(item) {
            return item.nazwa.toLowerCase().includes(filterText.toLowerCase());
        });
        this.refreshPanel(filteredItems);
    },
    updatePanel: function(firmaList, currentFirmaId) {
        this.dataFS = firmaList;
        this.currentObject = currentFirmaId;
        var radiogroup = this.down('radiogroupexd');
        radiogroup.removeAll();
        var newItems= this.buildRadioItems(this.dataFS);
        radiogroup.add(newItems);
    },
    refreshPanel: function(firmaList) {
        var radiogroup = this.down('radiogroupexd');
        radiogroup.removeAll();
        var newItems= this.buildRadioItems(firmaList);
        radiogroup.add(newItems);
    },
    saveOp: function() {
        var selected = this.down('radiogroup').getValue2();
        this.fireEvent('itemselected', this, {
            id: selected,
            name: selected !== 0 ? this.dataFS.find(function(item) { return item.id === selected; }).nazwa  : null
        });
    },
    closeOp: function() {
    }
});